import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AppState } from '../../../../app.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { Observable, Subject, Subscription } from 'rxjs';
import { ReplicatedService } from './replicated.service';
import { RefreshSharedService } from '../../../../refresh-shared-service';

@Component({
    selector: 'replicated-vdc-manage',
    providers: [ ReplicatedService ],
    styles: [
        require('./replicated-vdc.scss')
    ],
    encapsulation: ViewEncapsulation.None,
    template: require('./replicated-vdc-manage.html')
})

export class ReplicatedVdcManage {
    private subscription: Subscription;

    private result: any;
    private replicatedVdcs = [];
    private loading: boolean = true;
    private selectedVdc: any = null;
    private rsService: RefreshSharedService;
    private refreshSubscription: Subscription;
    private currentClassName: string = '';
    private loaded: boolean = false;
    @Input() currentTabId: number = 0;

    constructor(public service: ReplicatedService,
                private translate: TranslateService,
                private rss: RefreshSharedService) {
        translate.use(GlobalVariables.LOCALE);
        this.rsService = rss;
        this.currentClassName = 'ReplicatedVdcManage';    
    }

    getReplicatedVdcs() {
      this.loaded = false;
      this.subscription = this.service.getReplicatedVdcs()
      .subscribe(
      result => {
        this.loaded = true;  
        this.result = result;
        this.processData(this.result);
      },
      error => {
            this.service.logError(error, 'Error on loading replicated Vdcs manage');
            this.loaded = true; 
      },
      () => {
            this.service.logOperationCompleted('get replicated Vdcs manage for completed');
            this.loaded = true; 
      }
      );
    }

    processData(res) {
      if (res) {
        this.replicatedVdcs = res;
        if ( this.replicatedVdcs.length > 0 ) {
            this.onNodeClick( this.replicatedVdcs[0] );
        }
      } else {
        this.replicatedVdcs = [];
      }
      this.loading = false;
    }

    ngOnInit() {
        this.refreshSubscription = this.rsService.getRefreshParam()
        .subscribe (
        item => {
            this.handleEmittedValues(item);
        });

        this.rsService.setParam({
            'loadedComponent': this.currentClassName, 
            'detailPageIDName': '',
            'shouldReloadInventoryTree': true
        });
      this.getReplicatedVdcs();
    }

    handleEmittedValues(item) {
        if (item.loadedComponent === this.currentClassName) {
            this.getReplicatedVdcs();
        }
    }

    ngOnChanges(changes) {
        if (this.currentTabId === 2) {
            this.rsService.setParam({
                'loadedComponent': this.currentClassName, 
                'detailPageIDName': '',
                'shouldReloadInventoryTree': false
            });
        }
        this.loading = true;
        this.getReplicatedVdcs();
    }

    ngOnDestroy() {
        if( this.subscription ) {
            this.subscription.unsubscribe();
        }
        this.rsService.resetParam();
        if (this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }
    }

    onNodeClick = (vdc) => {
        if ( vdc ) {
            this.selectedVdc = vdc;
        }
    };

}




// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/replicated-vdc/replicated-vdc-manage.component.ts